import { Card } from 'src/components/atoms/Card';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  height: 20rem;
`;
